export default function Logo({ className = "h-8 w-auto" }) {
  return (
    <img
      src="/incer-logo.png"
      alt="Incer — Influence, Engineered"
      className={className}
    />
  );
}
